<template>
  <conciliation-action-btn
    v-if="!hasPendencies"
    label="conciliar sugestão"
    color="primary"
    :item="item"
    :disabled="!hasId"
    @reload-ted="reloadPage($event)"
  />

  <modals-request
    v-else
    v-model="payload"
    :title="setTitle"
    label="conciliar sugestão"
    :btn-attrs="{ color: 'primary', outlined: true }"
    :request-class="proxyRequest"
    :disabled-send="disabledSave"
    :config-swal="swalConfig"
    persistent
    @success="reloadPage($event)"
  >
    <form-group>
      <v-row
        v-for="(suggestion, idx) in getPendencies"
        :key="`suggestion_card_${idx}`"
      >
        <v-card
          class="elevation-2 py-2"
        >
          <v-card-text>
            <v-row>
              <v-col cols="2">
                <v-checkbox
                  @change="handleTransferId(suggestion.id)"
                />
              </v-col>
              <v-col cols="10">
                <conciliation-suggestion
                  color="#262626"
                  :value="suggestion"
                  autofill="Não retornado"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-row>
      <v-row class="pt-5">
        <v-textarea
          id="input:observation"
          v-model="payload.observation"
          label="Observação"
          :rules="[requiredRule, minLength(10)]"
          rows="5"
          outlined
        />
      </v-row>
    </form-group>
  </modals-request>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import ModalsRequest from '@/app/arch/components/modals/ModalsRequest.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import ConciliationActionBtn from './ConciliationActionBtn.vue';
import ConciliationSuggestion from './ConciliationSuggestion.vue';
import ConciliationTedMixin from './ConciliationTedMixin';

export default {
  name: 'ConciliationModalBtn',
  components: {
    FormGroup, ModalsRequest, ConciliationActionBtn, ConciliationSuggestion,
  },
  mixins: [ConciliationTedMixin, RulesMixin],
  props: {
    row: {
      type: Object,
      default() {
        return {
          pendingTransfers: [],
          bankAccount: {},
        };
      },
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    selectedTransferId: '',
  }),
  computed: {
    hasId() {
      return this.value;
    },
    item() {
      return this.row;
    },
    getPendencies() {
      return this.item.pendingTransfers.filter(
        (pendencie) => pendencie.situation === 'Pendente',
      );
    },
    hasPendencies() {
      return this.getPendencies && this.getPendencies.length >= 1;
    },
    setTitle() {
      return this.hasPendencies
        ? 'Escolha uma das pendencias disponíveis para realizar a conciliação'
        : 'Deseja conciliar?';
    },
    getTransferId() {
      return this.selectedTransferId;
    },
    handleTransferId() {
      return (id) => {
        this.selectedTransferId = id;
      };
    },
    disabledSave() {
      return !this.selectedTransferId
      || this.payload.observation.length < 10;
    },
    reloadPage() {
      return this.crudForm.reloadEdit;
    },
  },
  methods: {
    preparePayload(payload = {}) {
      return {
        ...payload,
        clientId: this.item.clientId,
        conciliationId: this.getId,
        bankTransferId: this.getTransferId,
        accountNumber: this.item.bankAccount.accountNumber,
        accountVerificationDigit: this.item.bankAccount.accountVerificationDigit,
        originName: this.item.clientName,
        originDocument: this.item.clientDocument.replace(/[^0-9]/g, ''),
      };
    },
  },
  inject: {
    crudForm: {
      default() {
        return {
          reloadEdit: (v) => v,
        };
      },
    },
  },
};
</script>
